import { Dialog } from 'primereact/dialog';
import { usePendingTimesheet } from '../../Hooks/Features/Timesheet/usePendingTimesheet';
import { TabView, TabPanel } from 'primereact/tabview';
import ApproveTimesheet from './ApproveTimesheet';
import { useCommon } from '../../Hooks/Common/useCommon';
import PenddingTimeSheetList from './PenddingTimeSheetList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PendingTimesheet = (props) => {

    const { ref, activeIndex, setActiveIndex, userOptions } = usePendingTimesheet();
    const { checkPermission } = useCommon();

    const customHeaderTemplate = (options, title, icon) => {
        return (
            <div className="d-flex align-items-center gap-2" onClick={options.onClick}>
                <FontAwesomeIcon icon={icon} />
                {options.active && <span className="white-space-nowrap">{title}</span>}
            </div>
        );
    };

    return (
        <div className='container'>
            <Dialog header="Confirm Timesheet" modal={true} draggable={false} className='modal-large pending-timesheet-dialog' visible={props?.timeSheetOpen} onHide={() => props?.setTimeSheetOpen(false)} >
                <div className='pending-timesheet'>
                    <TabView activeIndex={activeIndex} onTabChange={(e) => { setActiveIndex(e.index) }}>
                        <TabPanel header="Approve Timesheet" headerTemplate={(e) => customHeaderTemplate(e, "Approve Timesheet", "fa-solid fa-circle-check")}>
                            <div ref={() => checkPermission("timesheet", ref)}>
                                <div ref={ref} id='{"tabname": "timesheet", "data": "approve_timesheet_tab"}'>
                                     <ApproveTimesheet userOptions={userOptions} hover={props?.hover} />
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Pending Timesheet" headerTemplate={(e) => customHeaderTemplate(e, "Pending Timesheet", "fa-solid fa-clock")}>
                            <PenddingTimeSheetList setTimeSheetOpen={props?.setTimeSheetOpen} timeSheetOpen={props?.timeSheetOpen} userOptions={userOptions} hover={props?.hover} />
                        </TabPanel>
                    </TabView>
                </div>
            </Dialog>
        </div>
    )
}

export default PendingTimesheet